import axios from 'axios';
import { API_BASE_URL } from '../config';

/**
 * Calls backend GET /vip/profile.
 * Tier rules, spend, and benefits all come from the server — nothing is defined here.
 */
export async function fetchVipProfile(year) {
    const token = localStorage.getItem('token');
    if (!token || localStorage.getItem('guestUser') === 'true') {
        return null;
    }

    const params = year ? { year } : {};
    const { data } = await axios.get(`${API_BASE_URL}/vip/profile`, {
        params,
        headers: { Authorization: `Bearer ${token}` },
    });

    if (!data?.success) {
        throw new Error(data?.message || 'Failed to load VIP profile');
    }

    return data;
}
